import localStore from '../utils/localStore'
import JsonUtils from '../utils/json'

let state = {
  accessToken:'',//jwtToken
  activeTab: 2, // 默认tab
  isLogin: false, // 是否已经登录
  userId: '', // 用户uuid
  userPhone: '', // 手机号
  userName: '', // 姓名
  power: [], // 权限
  saveTree: ''
}

const mutations = {
  updateAccessToken(state, accessToken) {
    state.accessToken = accessToken
  },
  updateActiveTab(state, activeTab) {
    state.activeTab = activeTab
  },
  updatePower(state, power) {
    console.log(power)
    state.power = power
  },
  updateIsLogin(state, isLogin) {
    state.isLogin = isLogin
  },
  updateUserId(state, userId) {
    state.userId = userId
  },
  updateUserPhone(state, userPhone) {
    state.userPhone = userPhone
  },
  updateUserName(state, userName) {
    state.userName = userName
  },
  updateSaveTree(state, saveTree) {
    state.saveTree = saveTree
  },
  // save(state, user) {
  //   state.user = user
  //   if (user !== null) {
  //     state.uid = user.id
  //     state.name = user.username
  //     state.utoken = user.api_token
  //     localStore.setItem('mobUser', JsonUtils.jsonToString(state.user))
  //   }
  // },
  // flash(state) {
  //   let tmp = localStore.getItem('mobUser', null)
  //   let user = tmp === null ? null : JsonUtils.stringToJson(tmp)
  //   state.user = user
  //   if (user !== null) {
  //     state.uid = user.id
  //     state.name = user.username
  //     state.utoken = user.api_token
  //   }
  // },
  clear(state) {
    state.accessToken=''
    state.activeTab = 2
    state.isLogin = false
    state.userId = ''
    state.userName = ''
    state.userPhone = ''
    state.power = []
    state.saveTree = ''
    // localStore.removeItem('mobUser')
  }
}

// 事件触发后的逻辑操作
// 参数为事件函数
const actions = {
  updateAccessToken({ commit }, accessToken) {
    commit('updateAccessToken', accessToken)
  },
  updateActiveTab({ commit }, activeTab) {
    commit('updateActiveTab', activeTab)
  },
  updatePower({ commit }, power) {
    commit('updatePower', power)
  },
  updateIsLogin({ commit }, isLogin) {
    commit('updateIsLogin', isLogin)
  },
  updateUserId({ commit }, userId) {
    commit('updateUserId', userId)
  },
  updateUserPhone({ commit }, userPhone) {
    commit('updateUserPhone', userPhone)
  },
  updateUserName({ commit }, userName) {
    commit('updateUserName', userName)
  },
  updateSaveTree({ commit }, saveTree) {
    commit('updateSaveTree', saveTree)
  }
  // updateNav({ commit }, msg) {
  //   commit('mobUser', { uid: '', name: '' })    // 提交到mutations中处理
  // }
}

// 返回改变后的数值
const getters = {
  accessToken: state => state.accessToken,
  activeTab: state => state.activeTab,
  isLogin: state => state.isLogin,
  userId: state => state.userId,
  userName: state => state.userName,
  userPhone: state => state.userPhone,
  power: state => state.power,
  saveTree: state => state.saveTree
}

export default {
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/mineStore.js